import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../../common/types';
import { calendarMessages } from './calendarMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MoveUndoNoteProps {
  /** "Moved to Thursday 29 October, 18:00. It is still a draft." Null: no note. */
  text: string | null;
  onUndo: () => void;
  onClose: () => void;
}

/** The note after a move, with Undo (design b6). The toasts of the app have no action. */
const MoveUndoNoteComponent: React.FC<MoveUndoNoteProps> = ({ text, onUndo, onClose }) => {
  const intl = useIntl();
  if (text === null) {
    return null;
  }
  return (
    <div className={styles.toast} role="status" data-testid="calendar-move-note">
      <span>{text}</span>
      <button type="button" className={styles.linkBtn} onClick={onUndo}>
        {intl.formatMessage(calendarMessages.undo)}
      </button>
      <button
        type="button"
        className={styles.toastClose}
        aria-label={intl.formatMessage({ id: 'app.sml.promote.calendar.panel.close', defaultMessage: 'Close' })}
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const MoveUndoNote = TypedMemo(MoveUndoNoteComponent);
